import { Dimensions } from "~/ui/primitives"

const APP_MAX_WIDTH = 500
const GALLERY_TOOLS_BAR_HEIGHT = 60
const GALLERY_CONTAINER_BOTTOM_PADDING = 24

/** 聊天单图最大显示宽度 */
export const CHAT_IMAGE_MAX_WIDTH = 200
/** 多图消息间距 */
export const CHAT_IMAGE_GROUP_GAP = 6

/** 聊天室内图片/视频气泡最大显示尺寸（基于 500px 主内容区，而非整屏宽） */
export function getChatMediaMaxBounds() {
  const { width: windowWidth, height: windowHeight } = Dimensions.get("window")
  const contentWidth = Math.min(windowWidth, APP_MAX_WIDTH)
  return {
    contentWidth,
    maxWidth: Math.min(contentWidth * 0.4, CHAT_IMAGE_MAX_WIDTH),
    maxHeight: windowHeight * 0.5 * (0.4 / 0.6),
  }
}

/** 图片/视频预览区可用宽高（500px 居中容器内） */
export function getGalleryPreviewBounds() {
  const { width: windowWidth, height: windowHeight } = Dimensions.get("window")
  return {
    maxWidth: Math.min(windowWidth, APP_MAX_WIDTH),
    maxHeight: windowHeight - GALLERY_TOOLS_BAR_HEIGHT - GALLERY_CONTAINER_BOTTOM_PADDING,
  }
}

/**
 * 等比缩放至不超过 maxWidth / maxHeight。
 * 高超宽以高度为限，宽超则以宽度为限。
 */
export function fitContainSize(
  naturalWidth: number,
  naturalHeight: number,
  maxWidth: number,
  maxHeight: number,
) {
  if (!naturalWidth || !naturalHeight || !maxWidth || !maxHeight) {
    return { width: maxWidth, height: maxHeight }
  }
  const scale = Math.min(maxWidth / naturalWidth, maxHeight / naturalHeight)
  return {
    width: Math.max(1, Math.round(naturalWidth * scale)),
    height: Math.max(1, Math.round(naturalHeight * scale)),
  }
}
